import "./IntroCompany.css";
import Footer from "../../Footer";
const IntroCompany = () => {
  return (
    <div className="layout">
    <div className="home-page-content">
        <div className="introCompany">
            <h1 className="font-nm">
            세상에 꼭 필요한 책을 <span>출간하는 <em >에이콘출판사</em></span>
            </h1>
            <div className="intro-comment">
            <p>
                에이콘출판사는 1996년 출발한 이래 국내 컴퓨터와 인터넷 분야에서 IT 전문가들에게 지식과 혜안을 전달하는 책을 출간해왔습니다.
                단지 프로그래밍 기술뿐만 아니라 비즈니스와 문화, 과학, 인문 등의 분야와 융합하는 책을 출간함으로써 IT 기술을 인간에 접목하여
                더 나은 기술 문화와 문명을 만들고 새로운 비즈니스 분야를 개척하는 데 일조하고 있습니다.
            </p>
            <p>
                에이콘출판사는 임베디드 분야에서 출발해 기술 에세이의 장을 열었으며 지금은 해킹보안, 웹 프로페셔널, 게임, 모바일, UX,
                오픈소스, 소셜미디어, 비즈테크(biz-tech) 분야까지 누구나 알 만한 굵직굵직한 책을 펴냄으로써 컴퓨터 비트(bit)가 기반이 되는
                세상의 모든 이야기를 담아내고 있습니다.
            </p>
            <p className="p-em font-nm">
                “에이콘출판사는 남이 만든 트렌드를 쫓아가기보다는 스스로 세상을 선도하고 개척하는 책을 출간하고자 노력합니다.”
            </p>
            {/* <span>
                <span className="ceo font-nm">대표이사 옥경석</span>
            </span> */}
            </div>
            <div className="deco">
            <img src="/images/introCompany.png" alt="에이콘출판사 소개 이미지" />
            </div>
        </div>        
    </div>
    <Footer />
    </div>
  );
};

export default IntroCompany;